import React from 'react';
import PropTypes from 'prop-types';
import { getCurrentSiteBranding } from '@Lib/siteBranding';

const SiteLogo = ({ width = 260, className = 'site-logo', style = {}, ...props }) => {
  const siteBranding = getCurrentSiteBranding();

  const logoStyle = siteBranding.logo_max_height
    ? { maxHeight: siteBranding.logo_max_height, ...style }
    : style;

  return (
    <img
      src={siteBranding.logo_url}
      width={width}
      className={className}
      alt={siteBranding.name}
      style={logoStyle}
      {...props}
    />
  );
};

SiteLogo.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  style: PropTypes.object,
};

export default SiteLogo;
